export default "__VITE_ASSET__BraSL5L0__"